import { render, staticRenderFns } from "./riskUserConf.vue?vue&type=template&id=613d7eb8&scoped=true"
import script from "./riskUserConf.vue?vue&type=script&lang=ts"
export * from "./riskUserConf.vue?vue&type=script&lang=ts"
import style0 from "./riskUserConf.vue?vue&type=style&index=0&id=613d7eb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d7eb8",
  null
  
)

export default component.exports